// Browser-safe stub for Node's `perf_hooks` (used by NestJS injector timing).
const now =
  typeof performance !== 'undefined' && typeof performance.now === 'function'
    ? () => performance.now()
    : () => Date.now();

module.exports = {
  performance: { now },
  PerformanceObserver: class PerformanceObserver {
    observe() {}
    disconnect() {}
  },
};
